<template>
  <footer class="footer">
    <ul class="footer__list">
      <li class="footer__list--item">
        <router-link
          :to="{ path: `/${langPath}privacy` }"
          class="footer__list--item__link"
        >
          {{ Footer.privacy[lang] }}
        </router-link>
      </li>
      <li class="footer__list--item">
        <router-link
          :to="{ path: `/${langPath}question` }"
          class="footer__list--item__link"
        >
          FAQ
        </router-link>
      </li>
      <li class="footer__list--item">
        <router-link
          :to="{ path: `/${langPath}contact` }"
          class="footer__list--item__link"
        >
          {{ Footer.contact[lang] }}
        </router-link>
      </li>
      <li class="footer__list--item">
        <a
          :href="Footer.pdf[lang]"
          target="_blank"
          rel="noopener"
          class="footer__list--item__link"
        >
          {{ Footer.regulation[lang] }}
        </a>
      </li>
    </ul>
    <small class="copy-right flex-all-center">
      © Tokyo Marathon Foundation All Rights Reserved
    </small>
  </footer>
</template>

<script>
import Footer from "../../assets/constants/footer";
export default {
  computed: {
    Footer: function () {
      return Footer;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  name: "CommonFooter",
};
</script>

<style scoped>
.footer {
  padding: 25px 15px 15px 15px;
  background-color: var(--defaultBlackColor);
  &__list {
    &--item {
      padding: 25px 0;
      &__link {
        font-size: 16px;
        color: var(--defaultWhiteColor);
      }
    }
  }
  .copy-right {
    margin: 15px 0 0 0;
    font-size: 12px;
    font-weight: 300;
    color: var(--defaultWhiteColor);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/CommonFooter.vue